<template>
  <Transition name="fade-transform" mode="out-in">
    <BidsAddBulkDrop v-if="stage === 1" @upload="setCSVDataAndGoToNextStage" />
    <BidsAddBulkColumnChooser
      v-else-if="stage === 2"
      :csv-data="csvData"
      @choose="setSelectedColumnAndGoToNextStage"
      @cancel="resetCSVDataAndGoToPrevStage"
    />
    <BidsAddBulkPricing
      v-else-if="stage === 3"
      :keywords="selectedColumnData"
      @save="done"
      @cancel="resetSelectedColumnAndGoToPrevStage"
    />
  </Transition>
</template>

<script>
import BidsAddBulkDrop from './BidsAddBulkDrop';
import BidsAddBulkColumnChooser from './BidsAddBulkColumnChooser';
import BidsAddBulkPricing from './BidsAddBulkPricing';

export default {
  name: 'BidsAddBulk',
  components: {
    BidsAddBulkDrop,
    BidsAddBulkColumnChooser,
    BidsAddBulkPricing,
  },
  data() {
    return {
      stage: 1,
      csvData: [],
      selectedColumn: -1,
    };
  },
  computed: {
    selectedColumnData() {
      if (this.selectedColumn === -1) return [];
      return this.csvData[this.selectedColumn];
    },
  },
  methods: {
    resetCSVDataAndGoToPrevStage() {
      this.csvData = [];

      this.goToPrevStage();
    },
    resetSelectedColumnAndGoToPrevStage() {
      this.selectedColumn = -1;

      this.goToPrevStage();
    },
    setCSVDataAndGoToNextStage(data) {
      this.csvData = data;

      this.goToNextStage();
    },
    setSelectedColumnAndGoToNextStage(selectedColumn) {
      this.selectedColumn = selectedColumn;

      this.goToNextStage();
    },
    goToNextStage() {
      this.stage += 1;
    },
    goToPrevStage() {
      this.stage -= 1;
    },
    done() {
      this.$router.push({ name: 'search-ads-campaign-bids' });
    },
  },
};
</script>
